document.addEventListener('DOMContentLoaded', function () {
  if ($(window).width() < 750){
   $(".main_product_image-wrapp").flickity({
    wrapAround: true,
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    cellAlign: 'center', // Ensures smooth alignment
    draggable: true, // Enables smooth dragging
    freeScroll: true, // Allows continuous scrolling
    friction: 0.2, // Reduces resistance for smooth movement
    selectedAttraction: 0.01, // Lower values make the transition smoother
});
  var isManualInteraction = false;
  var swiper = new Swiper('.main_product_image-wrapp_mobile', {
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 12,
    speed: 400,
    on: {
        touchStart: function() {
            isManualInteraction = true;
        },
        slideChangeTransitionStart: function() {
            if (isManualInteraction) {
                $(".thumbnails_image-wrapp").flickity('select', this.realIndex);
            }
        },
        slideChangeTransitionEnd: function() {
            if (isManualInteraction) {
                var direction = this.realIndex > this.previousIndex ? 'right' : 'left';
                var get_prev_index = parseInt(this.realIndex) + 1;
                var product_title = $(".product__title h1").text();
                var trimed_title = $.trim(product_title);
                dataLayer.push({
                    'event': 'product_image_swipe',
                    'swipe_direction': direction,
                    'image_position': get_prev_index,
                    'product_title': trimed_title
                });
                isManualInteraction = false;
            }
        }
    }
});
    swiper.on('slideChange', function () {
        $("ul.show_mb.cc-creame-product.MobileDotsWp li.DotsMbPr").removeClass("active")
        $("ul.show_mb.cc-creame-product.MobileDotsWp li.DotsMbPr[data-index='" + this.realIndex + "']").addClass("active");
    });
    function slideToIndex(index) {
        swiper.slideTo(index);
    }
    $(".DotsMbPr").click(function() {
        var data_index = $(this).attr("data-index");
        slideToIndex(data_index); 
    });
// Handle thumbnail clicks for mobile
$(document).on('click', '.thumbnails_image-wrapp .thumb_image_inner', function() {
    var index = $(this).index();
    if (swiper) {
        swiper.slideTo(index);
        isManualInteraction = true;
    }
});
}else{
    var flkty = new Flickity('.main_product_image-wrapp', {
        wrapAround: false,
        pageDots: true,
        draggable: false,
        prevNextButtons: false
    });

    // // Function to move to the second slide and stop further transitions
    // function goToSecondSlide() {
    //     flkty.select(1);
    // }

    // // Set a timeout to move to the second slide after 2 seconds
    // setTimeout(goToSecondSlide, 2000);

    var prevIndex = 0;
    $(document).off("click", ".thumb_image_inner").on("click", ".thumb_image_inner", function() {
        var index = $(this).data('index');
        var direction = index > prevIndex ? 'Right' : 'Left';
        var product_title = $(".product__title h1").text();
        var trimed_title = $.trim(product_title);
        dataLayer.push({
            'event': 'product_image_swipe',
            'swipe_direction': direction,
            'image_position': parseInt(index),
            'product_title': trimed_title
        });
        prevIndex = index;
    });
}
  const sliderThumbs = new Swiper(".thumbnails_image_popup_slider", {
  slidesPerView: 4.3,
  loop: false,
  spaceBetween: 8,
  freeMode: true,
slideToClickedSlide: true,
       navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    750: {
       slidesPerView: 7,
      spaceBetween: 17.13,
     freeMode: false
    }
  },
});
const sliderImages = new Swiper(".main_image_popup_slider ", {
loop: false,
spaceBetween: 10,
slidesPerView: 1,
touchEventsTarget: 'container',
    thumbs: {
    swiper: sliderThumbs
  },
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
    breakpoints: {
    750: {
        allowTouchMove: false,
disableOnInteraction: true,
    }
  },
  on: {
    slideChange: function() {
      var $thumbnails = $(".thumbnails_image-wrapp");
      var flkty = $thumbnails.data('flickity');
      var currentIndex = flkty.selectedIndex;
      var targetIndex = this.activeIndex;
      
      // Calculate direction and slide one by one
      var direction = targetIndex > currentIndex ? 1 : -1;
      var steps = Math.abs(targetIndex - currentIndex);
      
      function slideOneStep(step) {
          if (step < steps) {
              $thumbnails.flickity('next', direction < 0);
              setTimeout(() => slideOneStep(step + 1), 100);
          }
      }
      
      slideOneStep(0);
    }
  }
});
  sliderImages.on('slideChange', function (index) {
    var direction = sliderImages.realIndex > sliderImages.previousIndex ? 'right' : 'left';
      var product_title = $(".product__title h1").text();
  var trimed_title = $.trim(product_title);
      var image_position = parseInt(sliderImages.previousIndex) + 1
dataLayer.push({'event':'product_image_swipe','swipe_direction':direction,'image_position':image_position,'product_title':trimed_title});
});
$(".thumbnails_image-wrapp").flickity({
  asNavFor: ".main_product_image-wrapp",
  contain: true,
  pageDots: false,
  prevNextButtons: true,
  draggable: true,
  cellAlign: 'left',
  selectedAttraction: 0.025,
  friction: 0.28,
  wrapAround: false,
  arrowShape: 'M14.8498 34.45C14.5332 34.45 14.2165 34.3333 13.9665 34.0833C13.4832 33.6 13.4832 32.8 13.9665 32.3166L24.8332 21.45C25.6332 20.65 25.6332 19.35 24.8332 18.55L13.9665 7.68331C13.4832 7.19997 13.4832 6.39997 13.9665 5.91664C14.4498 5.4333 15.2498 5.4333 15.7332 5.91664L26.5998 16.7833C27.4498 17.6333 27.9332 18.7833 27.9332 20C27.9332 21.2166 27.4665 22.3666 26.5998 23.2166L15.7332 34.0833C15.4832 34.3166 15.1665 34.45 14.8498 34.45Z'
});

  $(".main_product_image-wrapp").on( 'change.flickity', function( event, index ) {
  if ( event.namespace == 'flickity' ) {
      $("ul.show_mb.cc-creame-product.MobileDotsWp li.DotsMbPr").removeClass("active")
      $("ul.show_mb.cc-creame-product.MobileDotsWp li.DotsMbPr[data-index='"+index+"']").addClass("active")
  }
});
//Chnage Slide when click on thumbnail image
$(".thumb_image_inner").on("click", function () {
  var index = $(this).attr("data-index") - 1; 
  swiper.slideToLoop ? swiper.slideToLoop(index) : swiper.slideTo(index);
});
$(document).on("click",".product__media-gallery .main_product_image-wrapp .main_image_inner",function() {
  var data_index = $(this).attr("data-index");
  slideToIndex(data_index); 
   $(".custom_pdp_zoom-poup-wrapp").addClass("active");
});
  function slideToIndex(index) {
  sliderImages.slideTo(index);
}
    function slideToIndex2(index) {
  sliderImages.slideTo(index);
}
  $(document).on("click",".product__media-gallery .main_product_image-wrapp_mobile .main_image_inner",function() {
  
  var data_index = $(this).attr("data-index");
  slideToIndex2(data_index); 
      $(".custom_pdp_zoom-poup-wrapp").addClass("active");
});
  $(document).on("click",".custom_pdp_zoom-poup-wrapp button.product-media-modal__toggle",function() {
    $(".custom_pdp_zoom-poup-wrapp").removeClass("active");
});
   // Initialize Panzoom on the container
    const zoomContainer = document.querySelector('.product-media-modal__content');
    if (!zoomContainer) {
        //console.error('Zoom container not found.');
        return;
    }

    const panzoom = Panzoom(zoomContainer, {
        maxZoom: 5,
        minZoom: 1,
        contain: 'outside'
    });

    // Optional: Add event listeners for zoom controls
    const zoomInButton = document.querySelector('.zoom-in');
    const zoomOutButton = document.querySelector('.zoom-out');

    if (zoomInButton) {
        zoomInButton.addEventListener('click', () => {
            panzoom.zoomIn();
            handleZoomChange();
        });
    } else {
        //console.warn('Zoom In button not found.');
    }

    if (zoomOutButton) {
        zoomOutButton.addEventListener('click', () => {
            panzoom.zoomOut();
            handleZoomChange();
        });
    } else {
        //console.warn('Zoom Out button not found.');
    }

    // Handle zoom changes
    function handleZoomChange() {
        const zoomLevel = panzoom.getScale();
        //console.log(`Current zoom level: ${zoomLevel}`); // For debugging

        if (zoomLevel > 1) {
            sliderImages.allowTouchMove = false; // Disable Swiper dragging
        } else {
            sliderImages.allowTouchMove = true;  // Enable Swiper dragging
        }
    }

    // Optional: Handle Panzoom zoom events
    zoomContainer.addEventListener('panzoomzoom', () => {
        handleZoomChange();
    });

});